export const TECHNICAL_ADMINISTRATOR = 'TECHNICAL_ADMINISTRATOR'
export const PROJECT_MANAGER = 'PROJECT_MANAGER'
export const CCE = 'CCE'
export const USER = 'USER'
export const ELECTED = 'ELECTED'



// WEBPACK FOOTER //
// ./src/lib/enums/user/role.js